import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';
import Dropdown from '../';
import './index.scss';

class CurrencyDropdown extends React.PureComponent {
  static displayName = 'CurrencyDropdown';

  static propTypes = {
    supportedCurrencies: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    currency: PropTypes.string,
    icon: PropTypes.node,
  };

  static defaultProps = {
    currency: 'usd',
    icon: null,
  };

  buildOptions = () => {
    return _.inject(
      this.props.supportedCurrencies,
      (acc, opt) => {
        acc[opt] = opt.toUpperCase();
        return acc;
      },
      {}
    );
  };

  render() {
    const dropdownProps = {
      options: this.buildOptions(),
      value: this.props.currency,
      defaultOption: 'USD',
      onChange: this.props.onChange,
      displayOptions: {
        compact: true,
      },
    };
    if (this.props.icon) {
      dropdownProps.icon = this.props.icon;
    }

    return (
      <div className="CurrencyDropdown">
        <Dropdown {...dropdownProps} />
      </div>
    );
  }
}

export default CurrencyDropdown;
